import ModalComponent from "@/common/Modal";
import { OptInModalProps } from "../types";
import { Box, Button, Text, Switch, Divider, Tabs, TabList, Tab, TabPanels, TabPanel } from "@chakra-ui/react";
import React, { useState, useEffect, useMemo } from 'react'
import './OptInForm.scss';
import StoreOptInConfig from './store-optin-config';
import { jusThisStoreValues, allStoreValues } from '@/utils/constants';
import { EditValuesToBeSavedInterface } from '@/model/editDetails.mjs';
import { getDealerActionsToBeSaved, getIsCreateDealerActionCompleted, getIsCreateDealerActionInprogress } from '@/explore/ducks/selectors';
import { setDealerActionsToBeSaved, setIsCreateDealerActionInprogress, callToCreateDealerAction, setOptinOptoutEdited, setDealerOptOutValue, setIsDealerOptOut } from '@/explore/ducks/slice';
import { DealerProfileType } from '@masterffl/dealer-profile-component';
import { getIsGlobalAdmin, getIsGlobalAdminRole, getIsMyFFLRole, getIsStoreAdmin, getStoreData, getIsGlobalOperationsRole, getIsGlobalOperations } from '@/redux/app-selectors';

import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { callToGetDealerDetail } from "../ducks/slice";

type OptInFormProps = {
  data: DealerProfileType;
  onNonFFLToggleChange: (changed: boolean) => void;
  onPerStoreActionsChange?: (actions: EditValuesToBeSavedInterface[]) => void;
  onPerStoreTabStateChange?: (isPerStoreTabActive: boolean) => void;
};

export function OptInForm({
  data,
  onNonFFLToggleChange,
  onPerStoreActionsChange,
  onPerStoreTabStateChange
}: OptInFormProps) {
  const dispatch = useDispatch();
  const isGlobalAdmin = getIsGlobalAdmin();
  const isMyFFLRole = getIsMyFFLRole();
  const dealerActionsToBeSaved = getDealerActionsToBeSaved();
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const isGlobalAdminRole = getIsGlobalAdminRole()
  const isGlobalOperationsRole = getIsGlobalOperationsRole()
  const isGlobalOperations = getIsGlobalOperations();
  const storeData = getStoreData()

  let optOutOptions = ''
  const [optinOptout, setOptinOptout] = useState('');
  const [optOutOptionFor, setOptOutOptionFor] = useState(
    Object.keys(allStoreValues).includes(optOutOptions)
      ? 'all_store'
      : Object.keys(jusThisStoreValues).includes(optOutOptions)
        ? 'just_this_store'
        : ''
  );
  const { isOptInForAll, isOptOutForAll, isOptOutForStore, isOptInForStore, isOptedOutForTransferFromNonFFLSeller = false } = data.businessDetails;
  const initialNonFFLToggleValue = !isOptedOutForTransferFromNonFFLSeller;

  // dynamically setting text for a store when toggle state is unchecked/ checked
  const [justThisStoreOption, setJustThisStoreOption] = useState(
    (optOutOptions === 'store') ? 'does not' : 'does'
  );
  // dynamically setting text for all stores when toggle state is unchecked/ checked
  const [allStoreOption, setAllStoreOption] = useState(
    optOutOptions === 'all' ? 'does not' : 'does'
  );
  // set default toggle text when modal opens  
  const [defaultStatusStore, setDefaultStatusStore] = useState(true);
  const [defaultStatusAllStore, setDefaultStatusAllStore] = useState(true);
  const [defaultStatusNonFFL, setDefaultStatusNonFFL] = useState(initialNonFFLToggleValue);
  const [isNonFFLToggleChanged, setIsNonFFLToggleChanged] = useState(false);
  const [selectedSettingsTab, setSelectedSettingsTab] = useState(0);

  useEffect(() => {
    if (isCreateDealerActionCompleted && !isCreateDealerActionInprogress) {
      if (optinOptout) {
        dispatch(setOptinOptoutEdited(optinOptout));
        dispatch(setDealerOptOutValue(optinOptout));
        dispatch(setIsDealerOptOut(optinOptout === 'all' || optinOptout === 'store'));
      }
    }
  }, [isCreateDealerActionCompleted]);

  const updateFinalOptinOptoutValue = () => {
    let optiOptout = '';
    if (optOutOptionFor === 'just_this_store') {
      if (justThisStoreOption === 'does not') optiOptout = 'store';
      else if (justThisStoreOption === 'does') optiOptout = 'opt_in_store';
    }
    if (optOutOptionFor === 'all_store') {
      if (allStoreOption === 'does') optiOptout = 'opt_in_all';
      else if (allStoreOption === 'does not') optiOptout = 'all';
    }
    const params = {
      value: optiOptout,
      name: 'optin_optout_value',
      license_key: data.primaryInboundDetails.licenseKey,
      type: 'add'
    };
    setOptinOptout(optiOptout);
    if (optiOptout && optiOptout != optOutOptions) {
      updateDealerAction(params);
    }
    else {
      updateDealerAction(params, true);
    }
  };

  const updateDealerAction = (
    editParams: EditValuesToBeSavedInterface,
    isAlreadyExist?: boolean
  ) => {
    if (isAlreadyExist) {
      const actions = dealerActionsToBeSaved.filter(
        action => action.name != editParams.name
      );
      dispatch(setDealerActionsToBeSaved(actions));
      return;
    }
    let recordExist = false;
    const actions = dealerActionsToBeSaved.map(action => {
      if (action.name === editParams.name && (typeof action.value === typeof editParams.value)) {
        recordExist = true;
        return editParams;
      }
      return action;
    });
    if (recordExist) dispatch(setDealerActionsToBeSaved(actions));
    else
      dispatch(
        setDealerActionsToBeSaved([...dealerActionsToBeSaved, editParams])
      );
  };

  // on change toggle state for all stores and single store   
  const onChangeOptinOptoutJustThisStore = (event: any, type: string) => {
    setOptOutOptionFor(type)
    if (type === 'just_this_store') {
      if (event.target.checked) setJustThisStoreOption('does'); //Optin for this store
      else setJustThisStoreOption('does not');  //Opt out for this store
    }
    if (type === 'all_store') {
      if (event.target.checked) setAllStoreOption('does'); //Optin for all stores 
      else {
        setAllStoreOption('does not');
      } //Optout for all stores
    }
  };

  // on change toggle state for non-FFL transfers
  const onChangeNonFFLToggle = (event: any) => {
    const checked = event.target.checked;
    const hasChangedFromInitial = checked !== initialNonFFLToggleValue;
    setDefaultStatusNonFFL(checked);
    setIsNonFFLToggleChanged(hasChangedFromInitial);

    if (!hasChangedFromInitial) {
      const actions = dealerActionsToBeSaved.filter((action) => {
        if (action.name !== 'optin_optout_value') {
          return true;
        }
        if (typeof action.value !== 'object' || action.value === null) {
          return true;
        }
        return !('isOptedOutForTransferFromNonFFLSeller' in action.value);
      });
      dispatch(setDealerActionsToBeSaved(actions));
      return;
    }
    
    // Add the non-FFL dealer action to be saved
    const params = {
      value: { isOptedOutForTransferFromNonFFLSeller: !checked },
      name: 'optin_optout_value',
      license_key: data.primaryInboundDetails.licenseKey,
      type: 'add'
    };
    updateDealerAction(params);
  };

  useEffect(() => {
    updateFinalOptinOptoutValue();
  }, [optOutOptionFor, justThisStoreOption, allStoreOption]);

  useEffect(() => {
    onNonFFLToggleChange(isNonFFLToggleChanged);
  }, [isNonFFLToggleChanged, onNonFFLToggleChange]);

  const showSettingsTabs = isGlobalAdminRole || isGlobalOperationsRole;

  useEffect(() => {
    onPerStoreTabStateChange?.(showSettingsTabs && selectedSettingsTab === 1);
  }, [showSettingsTabs, selectedSettingsTab, onPerStoreTabStateChange]);

  const preferencesIntro = (
    <Box className="update_preferences_text">
      <Text className={showSettingsTabs ? "update_preferences_text-global" : "update_preferences_title"}>Update this dealer’s opt-in preferences.</Text>
    </Box>
  );

  const allStoresToggle = (
    <Box className="toggle_section_wrapper">
      <Box className="toggle_section">
        <Text>
          Dealer{' '}
          <Text as="b">
            {defaultStatusAllStore
              ? isOptInForAll
                ? 'does'
                : 'does not'
              : allStoreOption === 'does not'
                ? 'does not'
                : 'does'}
          </Text>{' '}
          accept transfers from <Text as="b">all stores</Text>
        </Text>
        <Switch
          color={'red'}
          size="lg"
          onChange={(event: any) => {
            setDefaultStatusAllStore(false);
            onChangeOptinOptoutJustThisStore(event, 'all_store');
          }}
          isInvalid={!isOptInForAll && !isOptOutForAll}
          isChecked={defaultStatusAllStore ? (isOptInForAll ? true : false) : allStoreOption === 'does'}
          sx={{
            '& .chakra-switch__track': { bg: 'red.100' },
            '& .chakra-switch__thumb': { bg: 'red.600', border: '2px', borderColor: 'red.100' },
            '.chakra-switch__track[data-checked]:not([data-theme])': { backgroundColor: 'green.100' },
            '.chakra-switch__thumb[data-checked]:not([data-theme])': {
              backgroundColor: 'green.400',
              border: '2px',
              borderColor: 'green.100'
            }
          }}
        />
      </Box>
    </Box>
  );

  const perStoreToggle = (
    <Box className="toggle_section_wrapper">
      <Box className="toggle_section">
        <Text>
          Dealer{' '}
          <Text as="b">
            {defaultStatusStore
              ? isOptInForStore || (isOptInForAll && !isOptOutForStore)
                ? 'does'
                : 'does not'
              : justThisStoreOption === 'does not'
                ? 'does not'
                : 'does'}
          </Text>{' '}
          accept transfers with our store
        </Text>
        <Switch
          color={'red'}
          size="lg"
          onChange={(event: any) => {
            setDefaultStatusStore(false);
            onChangeOptinOptoutJustThisStore(event, 'just_this_store');
          }}
          isInvalid={!isOptInForStore && !isOptOutForStore}
          isChecked={
            defaultStatusStore
              ? ((isOptInForStore || (isOptInForAll && !isOptOutForStore)) ? true : false)
              : justThisStoreOption === 'does'
          }
          sx={{
            '& .chakra-switch__track': { bg: 'red.100' },
            '& .chakra-switch__thumb': { bg: 'red.600', border: '2px', borderColor: 'red.100' },
            '.chakra-switch__track[data-checked]:not([data-theme])': { backgroundColor: 'green.100' },
            '.chakra-switch__thumb[data-checked]:not([data-theme])': {
              backgroundColor: 'green.400',
              border: '2px',
              borderColor: 'green.100'
            }
          }}
        />
      </Box>
    </Box>
  );

  const showNonFflRow = isGlobalAdminRole || isGlobalOperationsRole || storeData?.is_multi_tenant;

  const nonFflToggle = showNonFflRow ? (
    <Box className="toggle_section_wrapper">
      <Box className="toggle_section">
        <Text>
          Do you accept transfers from <Text as="b">non-FFLs</Text>?
        </Text>
        <Switch
          color={'red'}
          size="lg"
          onChange={onChangeNonFFLToggle}
          isChecked={defaultStatusNonFFL}
          sx={{
            '& .chakra-switch__track': { bg: 'red.100' },
            '& .chakra-switch__thumb': { bg: 'red.600', border: '2px', borderColor: 'red.100' },
            '.chakra-switch__track[data-checked]:not([data-theme])': { backgroundColor: 'green.100' },
            '.chakra-switch__thumb[data-checked]:not([data-theme])': {
              backgroundColor: 'green.400',
              border: '2px',
              borderColor: 'green.100'
            }
          }}
          isDisabled={allStoreOption === 'does not' || justThisStoreOption === 'does not'}
        />
      </Box>
    </Box>
  ) : null;

  return (
    <Box>
      {showSettingsTabs ? (
        <Tabs
          variant="unstyled"
          className="opt-in-settings-tabs"
          index={selectedSettingsTab}
          onChange={(index) => setSelectedSettingsTab(index)}
          isLazy
          lazyBehavior="keepMounted"
        >
          <TabList className="opt-in-settings-tablist" role="tablist">
            <Tab className="opt-in-settings-tab" flex="0 0 auto" w="auto" minW={0}>
              Global Settings
            </Tab>
            <Tab className="opt-in-settings-tab" flex="0 0 auto" w="auto" minW={0}>
              Per Store Settings
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel className="opt-in-settings-tabpanel" p={6}>
              {preferencesIntro}
              {allStoresToggle}
              {nonFflToggle}
            </TabPanel>
            <TabPanel className="opt-in-settings-tabpanel" p={6}>
              <StoreOptInConfig
                dealerId={data._id}
                dealerProfileId={data?._id}
                licenseKey={data?.primaryInboundDetails?.licenseKey}
                onStoreActionsChange={(actions) => onPerStoreActionsChange?.(actions)}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      ) : (
        <>
          {preferencesIntro}
          {(isGlobalAdmin || isGlobalOperations || isMyFFLRole) ? allStoresToggle : perStoreToggle}
          {nonFflToggle}
        </>
      )}
      <Divider color={'#E5E7EB'} style={{ width: showSettingsTabs ? '100%' : '90%', margin: showSettingsTabs ? '0' : 'auto', marginBottom: showSettingsTabs ? '24px' : 'auto' }} />
    </Box>
  );
}

export default function OptInModal({
  isOpen,
  onClose,
  data
}: OptInModalProps) {
  const dispatch = useDispatch()
  const params: any = useParams()
  const dealerActionsToBeSaved = getDealerActionsToBeSaved();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted()
  const [isNonFFLToggleChanged, setIsNonFFLToggleChanged] = useState(false);
  const [perStoreActions, setPerStoreActions] = useState<EditValuesToBeSavedInterface[]>([]);
  const [isPerStoreTabActive, setIsPerStoreTabActive] = useState(false);

  const isGlobalAdminRole = getIsGlobalAdminRole()
  const isGlobalOperationsRole = getIsGlobalOperationsRole()

  const defaultValue = dealerActionsToBeSaved.map(item => item.value)[0]
  const { isOptInForAll, isOptOutForAll, isOptOutForStore, isOptInForStore } = data.businessDetails
  let value = ''
  if (isOptOutForStore) value = 'store';
  else if (isOptInForStore) value = 'opt_in_store';
  else if (isOptInForAll) value = 'opt_in_all';
  else if (isOptOutForAll) value = 'all';

  const showSettingsTabs = isGlobalAdminRole || isGlobalOperationsRole;
  const actionListToSave = useMemo(
    () => [...dealerActionsToBeSaved, ...perStoreActions],
    [dealerActionsToBeSaved, perStoreActions]
  );
  const onModalClose = () => {
    setPerStoreActions([]);
    setIsPerStoreTabActive(false);
    onClose();
  };

  const onSaveHandler = async () => {
    dispatch(setIsCreateDealerActionInprogress(true))
    dispatch(callToCreateDealerAction({ actionList: actionListToSave }));
  };

  useEffect(() => {
    if (!isCreateDealerActionInprogress && isCreateDealerActionCompleted) {
      setPerStoreActions([]);
      setIsPerStoreTabActive(false);
      dispatch(callToGetDealerDetail(params?.dealerId));
      onModalClose()
    }
  }, [isCreateDealerActionCompleted, isCreateDealerActionInprogress])

  const defaultSaveDisabled = !isNonFFLToggleChanged && (dealerActionsToBeSaved.length <= 0 || value === defaultValue);
  const saveDisabled = isPerStoreTabActive
    ? defaultSaveDisabled && perStoreActions.length <= 0
    : defaultSaveDisabled;

  return (
    <ModalComponent
      title="Opt-In"
      isOpen={isOpen}
      onClose={onModalClose}
      variant={2}
      className={`btns ${showSettingsTabs ? 'opt-in-settings-tabs' : ''}`}
      footer={
        <Box className="opt-in-footer">
          <Button
            className="cancel_btn"
            onClick={() => {
              onModalClose();
            }}
            isDisabled={isCreateDealerActionInprogress}
          >
            Cancel
          </Button>
          <Button
            className="save_btn"
            colorScheme="blue"
            background="#0C1E46"
            padding="8px 20px"
            onClick={onSaveHandler}
            isLoading={isCreateDealerActionInprogress}
            isDisabled={saveDisabled}
          >
            Save
          </Button>
        </Box>
      }

    >
      <OptInForm
        data={data}
        onNonFFLToggleChange={setIsNonFFLToggleChanged}
        onPerStoreActionsChange={setPerStoreActions}
        onPerStoreTabStateChange={setIsPerStoreTabActive}
      />

    </ModalComponent>
  )
}
